import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "fixed top-0 left-0 right-0" }
const _hoisted_3 = { class: "item-center flex-col justify-center p-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "mt-5 mr-72 h-12 w-20 rounded-md bg-sky-400 py-3 text-center font-semibold font-semibold font-semibold text-black hover:bg-sky-500 hover:text-white" }, " もどる ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 text-2xl font-bold" }, [
  /*#__PURE__*/_createTextVNode(" あなたがバスに送った"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("写真の一覧です ")
], -1)
const _hoisted_6 = { class: "m-4 flex justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_DeleteConfirm = _resolveComponent("DeleteConfirm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "toast",
        message: _ctx.toastMessage,
        result: _ctx.toastResult
      }, {
        default: _withCtx(() => [
          (_ctx.showToast)
            ? (_openBlock(), _createBlock(_component_Toast, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["message", "result"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.deletePhotoId)
        ? (_openBlock(), _createBlock(_component_DeleteConfirm, {
            key: 0,
            open: _ctx.deleteConfirmOpen,
            showModal: _ctx.deleteConfirmToggle,
            user: _ctx.user,
            "delete-photo-id": _ctx.deletePhotoId,
            showToast: _ctx.triggerToast,
            ref: "deleteMessage"
          }, null, 8, ["open", "showModal", "user", "delete-photo-id", "showToast"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: `/${_ctx.groupId}/user/photoupload`
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_5,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: photo.photoUrl,
                  class: "shadow-md"
                }, null, 8, _hoisted_7),
                _createElementVNode("button", {
                  class: "mx-2 h-8 text-3xl",
                  type: "button",
                  onClick: ($event: any) => (_ctx.deleteConfirmToggle(photo.id))
                }, " ❎ ", 8, _hoisted_8)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}